<ng-template>
  <div class="bg-white shadow-xl rounded-[14px] p-2 text-default font-semibold">
    <div class="overflow-y-auto flex flex-col gap-1 pr-1" (click)="close()">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
